module.exports = __webpack_public_path__ + "static/media/3p_def_img.fd1303d9.jpg";